import styled from 'styled-components';

import { Rewards as DefaultRewards } from './transaction.styled.default';

export * from './transaction.styled.default';

export const Rewards = styled(DefaultRewards)`
  padding-left: 2.5rem;

  ${Styles.mobile`
      padding-left: 0.5rem;
  `}
`;
